import { render, staticRenderFns } from "./SellerGuide.vue?vue&type=template&id=10ab99de&scoped=true"
import script from "./SellerGuide.vue?vue&type=script&lang=js"
export * from "./SellerGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ab99de",
  null
  
)

export default component.exports